/// <amd-module name="Artifacts/Root/types/PackageDependencyDetails" />

export interface PackageDependencyDetails {
  group: string;
  normalizedPackageName: string;
  packageId: string;
  packageName: string;
  packageVersionId: string;
  versionRange: string;
}
